var _g;
function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgFirstPoint(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 11.691,
    height: 12.49,
    viewBox: "0 0 11.691 12.49",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0422\\u043E\\u0447\\u043A\\u0430_\\u0430",
    "data-name": "\\u0422\\u043E\\u0447\\u043A\\u0430 \\u0430",
    transform: "translate(-43.854 -129.51)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Subtraction_1",
    "data-name": "Subtraction 1",
    d: "M3541.166,13198.491h-5.259v-.395c0-1.538-.006-4.221-.007-5.134l.015-.262a7.161,7.161,0,0,1-4.046-5.518.944.944,0,0,1,.223-.8,1.145,1.145,0,0,1,.837-.379.76.76,0,0,1,.791.683,5.841,5.841,0,0,0,2.3,3.956v-.024a14.988,14.988,0,0,1,2.574-.223,5.962,5.962,0,0,1,2.466.393l.006.009.007.01a.934.934,0,0,1,.248.134,5.671,5.671,0,0,1,1.626,2.187c.025.055.052.109.08.168l.01.019a3.964,3.964,0,0,1,.5,1.545,3.268,3.268,0,0,1-.556,1.431c-.05.086-.1.17-.142.249a5.773,5.773,0,0,1-1.681,1.956Zm-.273-5.549h0l.009,3.45a6.755,6.755,0,0,0,.469-.7c.136-.236.252-.484.368-.737.02-.044.034-.082.051-.128A6.137,6.137,0,0,0,3540.893,13192.942Zm-2.448-2.827a1.774,1.774,0,1,1,1.808-1.772A1.792,1.792,0,0,1,3538.444,13190.115Z",
    transform: "translate(-3488 -13056.491)",
    fill: "current",
    stroke: "current"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFirstPoint);
export default __webpack_public_path__ + "static/media/first_point.6b7cfe19444127f81a49e4e8ce61d45e.svg";
export { ForwardRef as ReactComponent };